export enum LOCK_TYPE {
  BASE = 'base', // 更新商品基础的乐观锁
  SKU = 'sku', // 更新商品单品的乐观锁
  MATERIAL = 'material', // 更新物料的乐观锁（版单的物料数据）
  BOM = 'bom', // 更新bom物料的乐观锁
  PROCESS = 'process', // 更新工序的乐观锁
  BUSINESSPART = 'businessPart', // 商品部位的乐观锁(尺寸指示)
  TECHNIQUE = 'technique', // 商品工艺的乐观锁
  IMG = 'img', // 商品图片的乐观锁
  ATTACHMENT = 'attachment', // 商品附件的乐观锁
  COLORIMG = 'colorImg', // 商品单品图片的乐观锁
  WASHINGMETHOD = 'washingMethod', // 商品洗涤方式的乐观锁
  PRICE = 'price', // 商品售价的乐观锁
  STORELOCATION = 'storeLocation', // 库位的乐观锁
  COLORS = 'colors', // 设计款颜色的乐观锁
  SIZES = 'sizes', // 设计款尺码的乐观锁
  MATERIALDEVS = 'materialDevs', // 面辅料的乐观锁
  PROCESSATTACHMENT = 'processAttachment', // 工序附件的乐观锁
  TECHNIQUEATTACHMENT = 'techniqueAttachment', // 工艺附件的乐观锁
  ACCOUNTITEMS = 'accountItems', // IE核价的其他费用
  SIZEMODEL = 'sizeModel', // 商品的尺码规格
  EXTERNALPROCESSINGFEE = 'externalProcessingFee', // 委外加工费
  DESIGNORDERPROCESS = 'designOrderProcess', // 版单的生产节点乐观锁
}

export type LockType = `${LOCK_TYPE}`;

export const LOCK_TYPE_NAME: { [key in LockType]?: string } = {
  [LOCK_TYPE.BASE]: '基本信息',
  [LOCK_TYPE.SKU]: '单品',
  [LOCK_TYPE.COLORIMG]: '单品',
  [LOCK_TYPE.BOM]: '物料清单BOM',
  [LOCK_TYPE.MATERIAL]: '物料数据',
  [LOCK_TYPE.PROCESS]: '生产工序节点',
  [LOCK_TYPE.BUSINESSPART]: '尺寸指示',
  [LOCK_TYPE.TECHNIQUE]: '工艺要求',
  [LOCK_TYPE.ATTACHMENT]: '附件',
  [LOCK_TYPE.WASHINGMETHOD]: '洗涤方式',
  [LOCK_TYPE.PRICE]: '价格',
  [LOCK_TYPE.STORELOCATION]: '库位',
  [LOCK_TYPE.COLORS]: '颜色',
  [LOCK_TYPE.SIZES]: '尺码',
  [LOCK_TYPE.MATERIALDEVS]: '面辅料信息',
  [LOCK_TYPE.PROCESSATTACHMENT]: '工序附件',
  [LOCK_TYPE.TECHNIQUEATTACHMENT]: '工艺附件',
  [LOCK_TYPE.ACCOUNTITEMS]: 'IE核价',
  [LOCK_TYPE.SIZEMODEL]: '尺码规格',
  [LOCK_TYPE.EXTERNALPROCESSINGFEE]: '委外加工费',
};

// 编辑商品颜色尺码需要的锁
export const checkEditGoodsColorSizeParts = [
  LOCK_TYPE.SKU, // 条码
  LOCK_TYPE.COLORIMG, // 颜色图片
  LOCK_TYPE.BUSINESSPART, // 尺寸指示
  LOCK_TYPE.BOM, // bom
  LOCK_TYPE.SIZEMODEL, // 尺码规格
  LOCK_TYPE.STORELOCATION, // 库位
];

// 编辑设计款颜色尺码需要的锁
export const checkEditDesignColorSizeParts = [
  LOCK_TYPE.COLORS, // 颜色
  LOCK_TYPE.SIZES, // 尺码
  ...checkEditGoodsColorSizeParts,
];
type LockTypeMap = {
  goods: {
    type: 1;
    locks: LockType[];
    nameMap: { [key in LockType]?: string };
  };
  design: {
    type: 2;
    locks: LockType[];
    nameMap: { [key in LockType]?: string };
  };
  designOrder: {
    type: 3;
    locks: LockType[];
    nameMap: { [key in LockType]?: string };
  };
};
export const LOCK_TYPE_MAP: LockTypeMap = {
  // locks中的锁顺序最好按页面板块顺序写
  goods: {
    type: 1,
    locks: [
      LOCK_TYPE.BASE, // 基本信息
      LOCK_TYPE.IMG, // 商品图片
      LOCK_TYPE.PRICE, // 价格
      LOCK_TYPE.BOM, // 物料清单BOM
      LOCK_TYPE.PROCESS, // 生产工序节点和附件
      LOCK_TYPE.SKU, // 条码
      LOCK_TYPE.COLORIMG, // 颜色图片
      LOCK_TYPE.EXTERNALPROCESSINGFEE, // 委外加工费
      LOCK_TYPE.SIZEMODEL, // 尺码规格
      LOCK_TYPE.BUSINESSPART, // 尺寸指示
      LOCK_TYPE.TECHNIQUE, // 工艺要求
      LOCK_TYPE.TECHNIQUEATTACHMENT, // 工艺附件
      LOCK_TYPE.WASHINGMETHOD, // 洗涤方式
      LOCK_TYPE.STORELOCATION, // 商品库位
      LOCK_TYPE.ACCOUNTITEMS, // IE核价
      LOCK_TYPE.ATTACHMENT, // 附件
    ],
    nameMap: LOCK_TYPE_NAME,
  },
  design: {
    type: 2,
    locks: [
      LOCK_TYPE.BASE, // 基本信息
      LOCK_TYPE.IMG, // 设计款图片
      LOCK_TYPE.COLORS, // 颜色
      LOCK_TYPE.SIZES, // 尺码
      LOCK_TYPE.PRICE, // 价格
      LOCK_TYPE.MATERIALDEVS, // 面辅料信息
      LOCK_TYPE.BOM, // 物料清单BOM
      LOCK_TYPE.PROCESS, // 生产工序节点
      LOCK_TYPE.PROCESSATTACHMENT, // 工序附件
      LOCK_TYPE.SKU, // 条码
      LOCK_TYPE.COLORIMG, // 颜色图片
      LOCK_TYPE.EXTERNALPROCESSINGFEE, // 委外加工费
      LOCK_TYPE.SIZEMODEL, // 尺码规格
      LOCK_TYPE.BUSINESSPART, // 尺寸指示
      LOCK_TYPE.TECHNIQUE, // 工艺要求
      LOCK_TYPE.TECHNIQUEATTACHMENT, // 工艺附件
      LOCK_TYPE.WASHINGMETHOD, // 洗涤方式
      LOCK_TYPE.STORELOCATION, // 商品库位
      LOCK_TYPE.ACCOUNTITEMS, // IE核价
      LOCK_TYPE.ATTACHMENT, // 附件
    ],
    nameMap: LOCK_TYPE_NAME,
  },
  designOrder: {
    type: 3,
    locks: [
      LOCK_TYPE.BASE, // 基本信息
      LOCK_TYPE.SKU, // 条码
      LOCK_TYPE.MATERIALDEVS, // 面辅料信息
      LOCK_TYPE.BOM, // 物料清单BOM
      LOCK_TYPE.MATERIAL, // 物料数据
      LOCK_TYPE.BUSINESSPART, // 尺寸指示
      LOCK_TYPE.TECHNIQUE, // 工艺要求
      LOCK_TYPE.TECHNIQUEATTACHMENT, // 工艺附件
      LOCK_TYPE.PROCESS, // 生产工序节点
      LOCK_TYPE.IMG, // 版单图片
      LOCK_TYPE.ATTACHMENT, // 附件
      LOCK_TYPE.DESIGNORDERPROCESS, // 生产节点
      LOCK_TYPE.PROCESSATTACHMENT, // 生产节点附件
    ],
    nameMap: {
      [LOCK_TYPE.BASE]: '打版信息',
      [LOCK_TYPE.SKU]: '打版数量',
      [LOCK_TYPE.MATERIALDEVS]: '面辅料信息',
      [LOCK_TYPE.BOM]: '物料清单BOM',
      [LOCK_TYPE.MATERIAL]: '物料数据',
      [LOCK_TYPE.BUSINESSPART]: '尺寸指示',
      [LOCK_TYPE.TECHNIQUE]: '工艺要求',
      // [LOCK_TYPE.TECHNIQUEATTACHMENT]: '工艺附件',
      [LOCK_TYPE.PROCESS]: '样衣节点',
      // [LOCK_TYPE.IMG]: '版单图片',
      // [LOCK_TYPE.ATTACHMENT]: '版单工艺附件',
      [LOCK_TYPE.DESIGNORDERPROCESS]: '生产节点',
      [LOCK_TYPE.PROCESSATTACHMENT]: '生产节点附件',
    },
  },
};

export type LockTypeMode = keyof typeof LOCK_TYPE_MAP;
